export default __webpack_public_path__ + "static/media/Blue-Line.f21a28d6.svg";